"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Button = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _TouchableOpacity = _interopRequireDefault(require("react-native-web/dist/cjs/exports/TouchableOpacity"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _color = _interopRequireDefault(require("color"));

var _Text = require("../Text");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  display: inline-block;\n  box-sizing: border-box;\n  align-items: center;\n\n  border-radius: ", "px;\n\n  cursor: ", ";\n\n  transition: all ", ";\n  > * {\n    transition: all ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        background-color: ", ";\n        padding: ", "px;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        background-color: transparent;\n        padding: ", "px;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        box-sizing: border-box;\n        background-color: transparent;\n        border-width: ", "px;\n        border-color: ", ";\n        padding: ", "px;\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var buttonTransitionTime = "350ms";
var borderWidth = 4;

var buttonVariantStyles = function buttonVariantStyles(p) {
  switch (p.variant) {
    case "secondary":
      {
        return (0, _styledComponents.css)(_templateObject(), borderWidth, p.disabled ? (0, _color["default"])(p.theme.colors.primary).desaturate(0.5).toString() : p.theme.colors.primary, p.theme.spacings.l - borderWidth);
      }

    case "tertiary":
      {
        return (0, _styledComponents.css)(_templateObject2(), p.theme.spacings.l);
      }
    // aka primary

    default:
      {
        return (0, _styledComponents.css)(_templateObject3(), p.disabled ? (0, _color["default"])(p.theme.colors.primary).desaturate(0.5).toString() : p.theme.colors.primary, p.theme.spacings.l);
      }
  }
};

var Button = (0, _styledComponents["default"])(_TouchableOpacity["default"])(_templateObject4(), buttonVariantStyles, function (p) {
  return p.theme.radii.none;
}, function (p) {
  return p.disabled ? "not-allowed" : "pointer";
}, buttonTransitionTime, buttonTransitionTime); // Determine the "color" prop based on which variant of the button it is

exports.Button = Button;

var buttonTextVariantColor = function buttonTextVariantColor(p) {
  switch (p.variant) {
    case "secondary":
      {
        return {
          color: p.disabled ? (0, _color["default"])(p.theme.colors.primary).desaturate(0.5).toString() : p.theme.colors.primary
        };
      }

    case "tertiary":
      {
        var colour = p.disabled ? (0, _color["default"])(p.theme.colors.onBackground).fade(0.5).toString() : p.theme.colors.onBackground;
        return {
          color: colour
        };
      }
    // aka primary

    default:
      {
        return {
          color: p.theme.colors.onPrimary
        };
      }
  }
};

var Text = (0, _styledComponents["default"])(_Text.Text).attrs(buttonTextVariantColor)(_templateObject5());
exports.Text = Text;